import { TournamentOrganizerFacade } from "./TournamentOrganizerFacade.js";
export class TournamentOrganizerStandingsCalculator {
    facade;
    constructor() {
        this.facade = new TournamentOrganizerFacade();
    }
    calculateStandings(tournament, players, games) {
        this.facade.initialize(tournament, games, players);
        const standings = this.facade.getStandings();
        return standings.sort((a, b) => b.matchPoints - a.matchPoints ||
            b.tiebreaker - a.tiebreaker ||
            b.player.value - a.player.value);
    }
}
